///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import isAuthorizedToView from "./isAuthorizedToView";
import messages from "./messages";
import { mode, rfqStatusTypes, userRole } from "./types";

export const isClosedReopenBlockedByExceedingTimeLimit = (modeDetails, summary) => {
  if (summary?.isCoyoteBid === true) {
    return false;
  }
  return (
    summary?.isCoyoteBid === false &&
    modeDetails.status?.value === rfqStatusTypes[5].value &&
    modeDetails.isReopenAllow === false
  );
};

export const getClosedBidReopenBlockedTooltipContent = (modeDetails, summary) =>
  isClosedReopenBlockedByExceedingTimeLimit(modeDetails, summary)
    ? messages.bidClosedCannotReopenPastThirtyDays.defaultMessage
    : null;

const disableConsideringPreviousState = modeDetails => {
  const undefinedStatus = 0;
  return (
    modeDetails.previousStatus === undefinedStatus ||
    (modeDetails.previousStatus &&
      modeDetails.previousStatus.value > modeDetails.status.value)
  );
};

const enableWhenBidModeIsArchived = (
  role,
  summary,
  loggedInUserRole,
  modeType
) => {
  return (
    role === loggedInUserRole &&
    summary &&
    summary.modes.some(m => m.mode === modeType && m.isArchived === true)
  );
};

const enableWhenLoggedInUserIsBidOwner = (role, summary, loggedInUserRole) => {
  return (
    role === loggedInUserRole &&
    summary &&
    isAuthorizedToView(role, summary.modes)
  );
};

const enableWhenTLModeIsRejected = (role, modeDetails) => {
  return !(
    (role === userRole.tlPricingAnalyst ||
      role === userRole.assetBasedPricingUser) &&
    modeDetails.status.value === rfqStatusTypes[1].value
  );
};

const getUserRole = role => {
  switch (role) {
    case userRole.salesRep:
      return userRole.salesRep;
    case userRole.assetBasedPricingUser:
      return userRole.assetBasedPricingUser;
    case userRole.tlPricingAnalyst:
    default:
      return userRole.tlPricingAnalyst;
  }
};

const disableRFQStatusForTLMode = (modeDetails, role, summary) => {
  let loggedInUserRole = getUserRole(role);
  const disableRFQStatus =
    disableConsideringPreviousState(modeDetails) ||
    isClosedReopenBlockedByExceedingTimeLimit(modeDetails, summary) ||
    (!enableWhenBidModeIsArchived(role, summary, loggedInUserRole, mode.tl) &&
      !enableWhenLoggedInUserIsBidOwner(role, summary, loggedInUserRole) &&
      enableWhenTLModeIsRejected(role, modeDetails));

  return disableRFQStatus;
};

const disableRFQStatusForLTLMode = (modeDetails, role, summary) => {
  const disableRFQStatus =
    disableConsideringPreviousState(modeDetails) ||
    isClosedReopenBlockedByExceedingTimeLimit(modeDetails, summary) ||
    (!enableWhenBidModeIsArchived(
      role,
      summary,
      userRole.ltlPricingAnalyst,
      mode.ltl
    ) &&
      !enableWhenLoggedInUserIsBidOwner(
        role,
        summary,
        userRole.ltlPricingAnalyst
      ));

  return disableRFQStatus;
};

const disableRFQStatusForIMDLMode = (modeDetails, role, summary) => {
  const disableRFQStatus =
    disableConsideringPreviousState(modeDetails) ||
    isClosedReopenBlockedByExceedingTimeLimit(modeDetails, summary) ||
    (!enableWhenBidModeIsArchived(
      role,
      summary,
      userRole.imdlPricingAnalyst,
      mode.imdl
    ) &&
      !enableWhenLoggedInUserIsBidOwner(
        role,
        summary,
        userRole.imdlPricingAnalyst
      ));

  return disableRFQStatus;
};

const disableRFQStatus = (modeType, modeDetails, role, summary) => {
  switch (modeType) {
    case mode.tl:
      return disableRFQStatusForTLMode(modeDetails, role, summary);
    case mode.ltl:
      return disableRFQStatusForLTLMode(modeDetails, role, summary);
    case mode.imdl:
      return disableRFQStatusForIMDLMode(modeDetails, role, summary);
    default:
      break;
  }
};

export default disableRFQStatus;
